module.exports = __webpack_public_path__ + "img/4.bdfbec08.png";